export const HELPDESK_LISTING = 'HELPDESK_LISTING'
export const USER_DROPDOWN = 'USER_DROPDOWN'
export const APPROVER_DROPDOWN = 'APPROVER_DROPDOWN'
export const SAVE_USER_CONFIG = 'SAVE_USER_CONFIG'
export const UPDATE_USER_CONFIG = 'UPDATE_USER_CONFIG'
export const GET_AUTOFILL_DATA = 'GET_AUTOFILL_DATA'
export const USER_CONFIG_STATUS = 'USER_CONFIG_STATUS'
export const USER_REQUEST = 'USER_REQUEST'
export const USE_CASES = 'USE_CASES'
export const USER_REQUEST_LIST = 'USER_REQUEST_LIST'
export const APPROVAL_PENDING_LIST = 'APPROVAL_PENDING_LIST'
export const REQUEST_BY_ID = 'REQUEST_BY_ID'
export const APPROVAL = 'APPROVAL'
export const BACK_TO_MODIFICATION_REQUEST = 'BACK_TO_MODIFICATION_REQUEST'
export const BACK_TO_MODIFICATION_RESPONSE = 'BACK_TO_MODIFICATION_RESPONSE'
export const REQUEST_FILTER = 'REQUEST_FILTER'
export const FINANCE_HIERARCHY_LISTING = 'FINANCE_HIERARCHY_LISTING'
export const BACK_TO_MODIFICATION_REQUEST_LIST = 'BACK_TO_MODIFICATION_REQUEST_LIST'
export const CSV_DOWNLOAD = 'CSV_DOWNLOAD'
export const MRF_NUMBER_BY_INVOICE_NUMBER = 'MRF_NUMBER_BY_INVOICE_NUMBER'